export default __webpack_public_path__ + "static/media/google-logo-9808.0590aaf0.png";